<template>
	<a
		v-if="fone"
		href="#"
		class="btn__whatsapp btn__whatsapp--fixed"
		v-whatsapp-link
		:data-fone="fone"
		:data-text="text"
		ref="refElement"
	>
		<WhatsappIcon />
		<div class="btn__whatsapp__text">
			<strong>Whatsapp</strong>
		</div>
	</a>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import WhatsappIcon from './WhatsappIcon.vue'

const props = defineProps({
	fone: {
		type: String,
		default: ''
	},
	text: {
		type: String,
		default: ''
	},
})
const refElement = ref(null)
let observer;

onMounted(() => {
	const creditos = document.querySelector('.creditos')

	if(!creditos) return

	check()

	function check() {
		const { top } = creditos.getBoundingClientRect()
		let y = 30

		if (top <= window.innerHeight) {
			y = Math.floor(window.innerHeight - top)
		}

		refElement.value.style.setProperty('--bottom', `${y}px`)

		observer = requestAnimationFrame(check)
	}
})
</script>
